import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calendar, Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const VerifyEmail = () => {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8 relative">
      <div className="absolute top-4 right-4 z-10">
        <LanguageSwitcher />
      </div>
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
          <Mail className="h-8 w-8 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-foreground">{t("auth.verify_title")}</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {t("auth.verify_desc")}
        </p>
        <Button variant="outline" asChild className="mt-6">
          <Link to="/login">{t("auth.back_to_login")}</Link>
        </Button>
      </div>
    </div>
  );
};

export default VerifyEmail;
